import React, { Fragment, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUserError, login } from "../../store/user";
import { Box, Button, TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Formik, ErrorMessage } from "formik";
import { loginSchema } from "./login-schema";
import logo from "../../Images/medsleep-logo.jpg";
import {
  isPatient,
} from "../../utils/constants";
import { history } from "../../utils/history";

const useStyles = makeStyles((theme) => ({
  logo: theme.logo,
  errorMessage: {
    marginTop: "1rem",
  },
}));

const Login = ({ ...props }) => {
  const classes = useStyles();

  useEffect(() => {
    const init = () => {};
    init();
  }, []);

  const onSubmit = async (values) => {
    const { login } = props;
    const { username, password } = values;
    const result = await login(username, password);
    const user = result && result.payload;

    if (user && user.user) {

      if (isPatient(user.user.roleId)) {
        
        if(user.user.resetPasswordRequired){
          history.push("/reset-password");
        }
        else{
          history.push("/patient-dashboard");
        }
      }   
      else {
        history.push("/application-management");
      }

    }
  };

  return (
    <Fragment>
      <Box
        sx={{
          minHeight: "calc(100vh - 180px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
        }}
      >
        <Formik
          initialValues={{ username: "", password: "" }}
          validationSchema={loginSchema}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          render={({
            values,
            setFieldValue,
            handleChange,
            handleSubmit,
            handleBlur,
            errors,
            touched,
            ...formProps
          }) => (
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%", maxWidth: 450 }}
            >
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <img src={logo} className={classes.logo} alt="MedSleep" />
              </Box>
              <TextField
                error={errors.username && touched.username ? true : false}
                name="username"
                type="text"
                label="Username"
                margin="normal"
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.username}
              />
              <ErrorMessage name="username">
                {(msg) => <div className="error error-message">{msg}</div>}
              </ErrorMessage>
              <TextField
                error={errors.password && touched.password ? true : false}
                name="password"
                type="password"
                label="Password"
                margin="normal"
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
              />
              <ErrorMessage name="password">
                {(msg) => <div className="error error-message">{msg}</div>}
              </ErrorMessage>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Login
              </Button>
            </Box>
          )}
        />
        {props.error && (
          <div className={`error error-message ${classes.errorMessage}`}>
            {props.error}
          </div>
        )}
      </Box>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    error: getUserError(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators({ login }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
